import { render, staticRenderFns } from "./EmbedPreview.vue?vue&type=template&id=2dc36364"
import script from "./EmbedPreview.vue?vue&type=script&lang=js"
export * from "./EmbedPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports